import { useSelector, shallowEqual } from 'react-redux';
import { AppState } from '../app-state';
import { EntityAttributes } from '../../interfaces/EntityAttributes.interface';
import { EntityState } from './entity-state';
import { JourneyTaskAttributes } from '../../interfaces/JourneyTaskAttributes.interface';
import { IRequirementViewModel } from "../../interfaces/RequirementsInScopeModel";

export const useEntityState = (): EntityState => {
  const entityState = useSelector(
    (state: AppState) => state.entity,
    shallowEqual
  );

  return entityState;
};

export const useSelectedEntity = (): EntityAttributes => {
  const selectedEntity = useSelector(
    (state: AppState) => state.entity.selectedEntity,
    shallowEqual
  );

  return selectedEntity;
};

export const useInitialJourneyTasks = (): JourneyTaskAttributes[] => {
  const selectedJourneyTasks = useSelector(
    (state: AppState) => state.entity.initialJourneyTasks,
    shallowEqual
  );

  return selectedJourneyTasks;
};

export const useLatestJourneyTasks = (): JourneyTaskAttributes[] => {
  const selectedJourneyTasks = useSelector(
    (state: AppState) => state.entity.latestJourneyTasks,
    shallowEqual
  );

  return selectedJourneyTasks;
};

export const useDynamicRequirements = (): IRequirementViewModel[] => {
  const dynamicRequirements = useSelector(
    (state: AppState) => state.entity.dynamicRequirements,
    shallowEqual
  );

  return dynamicRequirements;
};

export const useDynamicRequirementsFieldValue = (fieldName): string => {
  const dynamicRequirements = useSelector(
    (state: AppState) => state.entity.dynamicRequirements,
    shallowEqual
  ) || [];

  return dynamicRequirements.find(requirement => {
    return requirement.dataField?.propertyName === fieldName
  })?.defaultValue;
}